var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.reward
    ? _c("section", { staticClass: "container py-3" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12 col-lg-6 offset-lg-3" }, [
            _c(
              "div",
              { staticClass: "py-3" },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "text-primary-link",
                    attrs: { to: "/rewards" }
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("message.rewards.title")) +
                        "\n        "
                    )
                  ]
                ),
                _vm._v(" "),
                _c("i", { staticClass: "fal fa-angle-right" }),
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("message.rewards.detail")) +
                    "\n      "
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("img", {
              staticClass: "img-fluid rounded",
              attrs: { src: _vm.reward.image_url }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "my-4" }, [
              _c("h3", { staticClass: "text-center" }, [
                _vm._v(
                  _vm._s(
                    _vm.$i18n.locale === "th"
                      ? _vm.reward.title_th
                      : _vm.reward.title_en
                  )
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "d-flex" }, [
              _c("div", { staticClass: "flex-fill" }, [
                _c("div", [_vm._v(_vm._s(_vm.$t("message.rewards.points")))]),
                _vm._v(" "),
                _c("h4", { staticClass: "d-inline-block text-info" }, [
                  _vm._v(_vm._s(_vm._f("prettyNumber")(_vm.reward.points)))
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "text-secondary text-small" }, [
                  _vm._v(_vm._s(_vm.$t("message.rewards.points")))
                ])
              ]),
              _vm._v(" "),
              _c("div", {
                staticClass: "mx-3",
                staticStyle: {
                  width: "1px",
                  height: "40px",
                  "background-color": "#E0E0E0"
                }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "flex-fill" }, [
                _c("div", [
                  _vm._v(_vm._s(_vm.$t("message.rewards.redeem_by")))
                ]),
                _vm._v(" "),
                _c("h4", { staticClass: "d-inline-block" }, [
                  _vm._v(_vm._s(_vm._f("prettyOnlyDate")(_vm.reward.end_date)))
                ])
              ])
            ]),
            _vm._v(" "),
            _c("hr"),
            _vm._v(" "),
            _c("div", { staticClass: "pt-2" }, [
              _c("div", {
                domProps: {
                  innerHTML: _vm._s(
                    _vm.handleNewLine(
                      _vm.$i18n.locale === "th"
                        ? _vm.reward.content_th
                        : _vm.reward.content_en
                    )
                  )
                }
              })
            ]),
            _vm._v(" "),
            _vm.user
              ? _c("div", { staticClass: "py-3" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-info btn-block",
                      attrs: { disabled: !_vm.canRedeem() },
                      on: {
                        click: function($event) {
                          return _vm.displayConfirmDialog()
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("message.button.redeem")) +
                          "\n        "
                      )
                    ]
                  )
                ])
              : _vm._e()
          ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-185c5d80", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-185c5d80","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reward/RewardDetail.vue
// module id = 2298
// module chunks = 0